"use client";

import { Container } from "@/components/Container";
import { Reveal, RevealGroup, RevealItem } from "@/components/Motion";
import { clients } from "@/lib/home";

// "Our Clients" — mirrors the live site: the official client logo wall.
// Logos render grayscale and lift to full colour on hover (brand convention).
export function Clients({ c = {} }: { c?: Record<string, string> } = {}) {
  return (
    <section className="border-t border-brand-line bg-brand-paper py-24 md:py-32">
      <Container>
        <Reveal>
          <h2 className="max-w-3xl t-display text-brand-ink">
            Our <span className="text-brand-accent">Clients</span>
          </h2>
          <p className="mt-6 max-w-xl text-base font-normal leading-relaxed text-brand-slate md:text-lg">
            Table Space is trusted by leading global enterprises and some of the
            world&apos;s most renowned businesses.
          </p>
        </Reveal>

        <RevealGroup
          className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 md:mt-16 md:grid-cols-6 md:gap-4"
          stagger={0.025}
        >
          {clients.map((cl, i) => (
            <RevealItem key={cl.name}>
              {/* logo tiles are not clickable — no hover effect (req 1.6) */}
              {cl.logo ? (
                <span
                  title={cl.name}
                  className="flex h-20 items-center justify-center rounded-xl border border-brand-line bg-white px-5 md:h-24"
                >
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                    src={c[`clients.${i}.logo`]?.trim() || cl.logo}
                    alt={c[`clients.${i}.logo.alt`]?.trim() || cl.name}
                    data-cms-img={`clients.${i}.logo`}
                    loading="lazy"
                    decoding="async"
                    className="max-h-9 w-auto max-w-full object-contain opacity-90 md:max-h-10"
                  />
                </span>
              ) : (
                <span className="flex h-20 items-center justify-center rounded-xl border border-brand-line bg-white px-5 text-[0.72rem] font-medium uppercase tracking-[0.14em] text-brand-muted md:h-24">
                  {cl.name}
                </span>
              )}
            </RevealItem>
          ))}
        </RevealGroup>
      </Container>
    </section>
  );
}
